export default () => {
  if (!document.querySelector('[data-extra-seo]')) {
    return;
  }

  const toggleSeo = () => {
    document.querySelectorAll('[data-show-hide-seo]').forEach((element) => {
      element.classList.toggle('active');
    });

    document.querySelectorAll('[data-extra-seo]').forEach((element) => {
      element.classList.toggle('active');
    });
  };

  document.querySelectorAll('[data-show-hide-seo]').forEach((element) => {
    element.addEventListener('click', toggleSeo);
    element.addEventListener('touchend', toggleSeo);
  });
};
